import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
} from '../shared/schema'

/**
 * we are also using this schema for rebates
 * rebates do NOT give access to a section, but rather can be used to purchase
 * another section pass at a reduced price
 */
export const sectionPassSchema = z.object({
  createdAt: nullSafeOptionalFirestoreTimestamp(),
  paymentId: nullSafeOptionalString().nullable(),
  price: nullSafeOptionalNumber(),
  purchaseDate: nullSafeOptionalFirestoreTimestamp(),
  purchaseType: nullSafeOptionalString(),
  sectionId: nullSafeOptionalString(),
  creatorUserId: nullSafeOptionalString(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  userId: nullSafeOptionalString(),
  rebate: nullSafeOptionalBoolean().refine((val) => val !== true, {
    message: 'section pass document cannot have rebate=true',
  }),
  // set only when the pass was redeemed with a Breakout-level access code
  accessCodeId: nullSafeOptionalString(),
  accessCodeBatchId: nullSafeOptionalString(),
  accessCodeVendor: nullSafeOptionalString(),
})

export const sectionPassRebateSchema = sectionPassSchema.extend({
  consumedAt: nullSafeOptionalFirestoreTimestamp(),
  rebate: z.literal(true),
  price: z.number().int().positive(),
  rebatedFromSectionId: nullSafeOptionalString(),
  // written by the consumeRebates transaction when the rebate is applied
  // to a section pass purchase (see typescript/apps/functions/src/section_pass.ts)
  rebateAppliedToSectionId: nullSafeOptionalString(),
})

export const emptySectionPass = Object.freeze(sectionPassSchema.parse({}))
export const emptySectionPassRebate = Object.freeze(
  sectionPassRebateSchema.parse({
    rebate: true,
    price: 1,
  })
)

export type FirestoreUserProfileSectionPass = z.infer<typeof sectionPassSchema>
export type FirestoreUserProfileSectionPassRebate = z.infer<
  typeof sectionPassRebateSchema
>
